import { booking as api } from "@lab/api/meetings.api";
import { Booking, BookingDetial } from "@lab/types/bookings";
import { detailDateFields, bookingDateFields } from "@lab/meta/bookings";
import { is_date_set } from "@lab/utils/format";
import Bugsnag from "@/utils/bugsnag";

const state = {
	booking: null,
	isFetching: false,
	errorMessage: null
};

const getters = {
	detail: (state): BookingDetial => state.booking as BookingDetial,
	requests: (state): Booking[] => state.booking.bookinglistings as Booking[],
	error: (state): string => state.errorMessage as string,
	fetching: (state): boolean => state.isFetching as boolean
};

const actions = {
	async fetch({ commit, dispatch }, bookingid) {
		commit("LOAD_START");

		const _booking = await api.get(bookingid).catch((error) => {
			Bugsnag.notify(
				new Error(`Bookings super fetch: ${error.response.data.error}`)
			);
		});

		if (_booking) {
			return dispatch(`prepare`, _booking);
		}

		commit(`LOAD_FINISH`);
	},
	prepare({ commit }, booking) {
		if (detailDateFields.length) {
			detailDateFields.forEach((field) => {
				booking[field] = is_date_set(booking[field])
					? new Date(booking[field])
					: null;
			});
		}

		if (booking.bookinglistings && booking.bookinglistings.length) {
			booking.bookinglistings.forEach((booking) => {
				bookingDateFields.forEach((field) => {
					booking[field] = is_date_set(booking[field])
						? new Date(booking[field])
						: null;
				});
				if (booking.history) {
					booking.history.forEach((item) => {
						item.time = is_date_set(item.time)
							? new Date(item.time)
							: null;
					});
				}
			});
		}
		commit(`LOAD_BOOKING_SUCCESS`, booking);
	},
	async cancelRequest({ getters, commit }, { id, cancelmessage }) {
		// grab the request from the current bookings requests array
		let _request = getters.requests.find((item) => item.id === id);
		// // if it exists we need to cancel it via an update call
		if (_request) {
			_request = {
				..._request,
				status: "cancelled",
				cancelreason: "Cancelled by DailyCare admin",
				cancelmessage
			};
			await api.update(_request).catch((error) => {
				Bugsnag.notify(
					new Error(`Booking cancel: ${error.response.data.error}`)
				);
			});
		}
	}
};

const mutations = {
	LOAD_BOOKING_SUCCESS(state: any, booking: Booking) {
		if (!booking) return;
		state.booking = booking;
		state.isFetching = false;
		state.lastFetched = Date.now();
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
